export default __webpack_public_path__ + "static/media/newshome1.d28cc974.png";